import React, { useEffect, useState, useContext } from "react";
import Modal from "react-modal";
import "../../../../UcafForm/styles.css";
import myImage from "../../../../UcafForm/target001.png";
import { printElementToPdf } from "../../../../UcafForm/printUtils";
import { useTranslation } from "react-i18next";
import { appContext } from "../../../../context/ContextProvider";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    minHeight: "90%",
    maxHeight: "90%",
    minWidth: "90%",
  },
};

export function UCAFdata({ item }) {
  const { user } = useContext(appContext);
  const loggedUser = (() => {
    try {
      return JSON.parse(localStorage.getItem("user")) || {};
    } catch {
      return {};
    }
  })();

  const providerName =
    item?.provider_name ||
    item?.provider?.full_name ||
    item?.provider?.name ||
    item?.provider_name_en ||
    loggedUser?.FullName ||
    loggedUser?.full_name ||
    user?.FullName ||
    "";

  const headerOne = [
    { id: 1, name: "Code" },
    { id: 2, name: "Non-Standard Code" },
    { id: 3, name: "Description/Service" },
    { id: 4, name: "Type" },
    { id: 5, name: "Quantity" },
    { id: 6, name: "Approved Quantity" },
    { id: 7, name: "Cost" },
    { id: 8, name: "Approved Cost" },
    { id: 8, name: "Status" },
  ];
  const headerthree = [
    { id: 1, name: "Code" },
    { id: 2, name: "Reject Reason Code" },
    { id: 3, name: "Reject Reason Description" },
  ];
  const headerTwo = [
    { id: 1, name: "Medication Name (Generic Name)" },
    { id: 2, name: "Type" },
    { id: 3, name: "Quantity" },
  ];
  const headerTwoData = [
    { id: 1, name: "Medication Name (Generic Name)" },
    { id: 2, name: "Type" },
    { id: 3, name: "Quantity" },
  ];

  return (
    <div
      className="ucaf-form"
      style={{ fontSize: "12px", fontFamily: "Arial, sans-serif" }}
    >
      <h3 className="text-xl text-center font-bold mb-2">UCAF 2.0</h3>

      {/* First Row - Two Columns */}
      <div className="grid grid-cols-2 gap-2 mb-2">
        {/* Left Column */}
        <div className="border border-black p-1 rounded">
          <h3 className="text-sm font-bold mb-1">
            To be completed &amp; ID verified by the reception/nurse:
          </h3>
          <div className="space-y-1">
            <div className="flex items-center">
              <span className="font-semibold mr-1">Provider Name:</span>
              <span className="border-b border-dotted border-black flex-1">
                {providerName}
              </span>
            </div>
            <div className="flex items-center">
              <span className="font-semibold mr-1">
                Insurance Company Name:
              </span>
              <span className="border-b border-dotted border-black flex-1">
                {item?.payer_name}
              </span>
            </div>
            <div className="flex items-center">
              <span className="font-semibold mr-1">TPA Company Name:</span>
              <span className="border-b border-dotted border-black flex-1">
                {item?.tpa_name}
              </span>
            </div>
            <div className="flex items-center">
              <span className="font-semibold mr-1">Patient Document ID:</span>
              <span className="border-b border-dotted border-black flex-1">
                {item?.patient_document_id}
              </span>
            </div>
            <div className="flex items-center">
              <span className="font-semibold mr-1">Single () Married ():</span>
              <span className="mr-1">Plan Type</span>
              <span className="border-b border-dotted border-black flex-1">
                {item?.insurance_plan?.coverage_type}
              </span>
            </div>
            <div className="flex items-center">
              <span className="font-semibold mr-1">Date Of Visit:</span>
              <span className="border-b border-dotted border-black flex-1">
                No
              </span>
            </div>
            <div className="flex space-x-2">
              <span>New Visit()</span>
              <span>FollowUp()</span>
              <span>Refell()</span>
              <span>WalkIn()</span>
            </div>
            <div className="flex space-x-2">
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Referrel:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {item && item.is_referral ? "YES" : "NO"}
                </span>
              </div>
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Refer To:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {item?.refer_to || item?.reffered_hospital || ""}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div className="border border-black p-1 rounded">
          <h3 className="text-sm font-bold mb-1">
            Print &amp; fill in clear letters or Emboss Card:
          </h3>
          <div className="space-y-1">
            <div className="flex items-center">
              <span className="font-semibold mr-1">Insured Name:</span>
              <span className="border-b border-dotted border-black flex-1 capitalize">
                {item?.patient?.full_name}
              </span>
            </div>
            <div className="flex items-center">
              <span className="font-semibold mr-1">ID Card Number:</span>
              <span className="border-b border-dotted border-black flex-1">
                {item?.insurance_plan?.member_card_id}
              </span>
            </div>
            <div className="flex space-x-2">
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Sex:</span>
                <span className="border-b border-dotted border-black flex-1 capitalize">
                  {item?.patient?.gender}
                </span>
              </div>
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Date of Birth:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {item?.patient?.dob}
                </span>
              </div>
            </div>
            <div className="flex space-x-2">
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Policy Holder:</span>
                <span className="border-b border-dotted border-black flex-1">
                  YES
                </span>
              </div>
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Policy Number:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {item?.insurance_plan?.policy_number}
                </span>
              </div>
            </div>
            <div className="flex space-x-2">
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Date Of Expiry:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {item?.insurance_plan?.expiry_date}
                </span>
              </div>
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Class:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {item?.className}
                </span>
              </div>
            </div>
            <div className="flex space-x-2">
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Approval:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {item?.pre_auth_ref_no}
                </span>
              </div>
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Response Date:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {!(item?.status === "approved")
                    ? item?.response_date && item?.response_date?.length > 16
                      ? item?.response_date.substring(0, 16).replace("T", " ")
                      : item?.response_date
                    : null}
                </span>
              </div>
            </div>
            <div className="flex space-x-2">
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Approval Status:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {item?.status}
                </span>
              </div>
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Approval Date:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {item?.status === "approved"
                    ? item?.response_date && item?.response_date?.length > 16
                      ? item?.response_date.substring(0, 16).replace("T", " ")
                      : item?.response_date
                    : null}
                </span>
              </div>
            </div>
            <div className="flex items-start">
              <span className="font-semibold mr-1 whitespace-nowrap">Remarks:</span>
              <span className="border-b border-dotted border-black flex-1 break-words">
                {item?.disposition}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Second Row - Physician Section */}
      <div className="border border-black p-1 rounded mb-2">
        <h3 className="text-sm font-bold mb-1">
          To be completed by Attending PHYSICIAN : Please tick ()
        </h3>

        <div className="flex justify-between items-center mb-1">
          <div className="flex space-x-2">
            <span>Inpatient ()</span>
            <span>Outpatient ()</span>
          </div>
          <div className="border border-black rounded flex items-center p-1 space-x-2">
            <span>EmergencyCase ()</span>
            <div className="flex items-center">
              <span className="font-semibold mr-1">EmergencyCareLavel:</span>
              <div className="flex space-x-1">
                <span>1 ( )</span>
                <span>2 ( )</span>
                <span>3 ( )</span>
                <span>4 ( )</span>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-between mb-1">
          <div className="flex items-center">
            <span className="font-semibold mr-1">BP /:</span>
            <span className="border-b border-dotted border-black w-8"></span>
          </div>
          <div className="flex items-center">
            <span className="font-semibold mr-1">Pulse /:</span>
            <span className="border-b border-dotted border-black w-8"></span>
          </div>
          <div className="flex items-center">
            <span className="font-semibold mr-1">Temp /:</span>
            <span className="border-b border-dotted border-black w-8"></span>
          </div>
          <div className="flex items-center">
            <span className="font-semibold mr-1">Weight /:</span>
            <span className="border-b border-dotted border-black w-8"></span>
          </div>
          <div className="flex items-center">
            <span className="font-semibold mr-1">Height /:</span>
            <span className="border-b border-dotted border-black w-8"></span>
          </div>
          <div className="flex items-center">
            <span className="font-semibold mr-1">R.R /:</span>
            <span className="border-b border-dotted border-black w-8"></span>
          </div>
          <div className="flex items-center">
            <span className="font-semibold mr-1">Duration Of Line /:</span>
            <span className="border-b border-dotted border-black w-8"></span>
          </div>
        </div>

        <div className="mb-1">
          <div className="flex items-start">
            <span className="font-semibold mr-1">
              Chief Complaints and Main Symptoms:
            </span>
            <div className="border-b border-dotted border-black flex-1">
              {item?.supporting_info
                ?.filter((support) => support.category === "chief-complaint")
                ?.map((support) => (
                  <p key={support.sequence_no} className="font-semibold">
                    {/* {support.code} */} {support.code_text} {support.value}
                  </p>
                ))}
            </div>
          </div>
        </div>

        <div className="space-y-1 mb-1">
          <div className="flex items-center">
            <span className="font-semibold mr-1">Significant Signs:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div>
          <div className="flex items-center">
            <span className="font-semibold mr-1">Other Conditions:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div>
          <div className="flex items-center">
            <span className="font-semibold mr-1">Diagnosis:</span>
            <span className="border-b border-dotted border-black flex-1">
              {item?.diagnosis
                ?.map((diag) => {
                  return `${diag.code} - ${diag.description}`;
                })
                ?.join(", ")}
            </span>
          </div>
        </div>

        <div className="flex space-x-1 mb-1">
          <div className="flex items-center flex-1">
            <span className="font-semibold mr-1">Principal Code:</span>
            <span className="border-b border-dotted border-black flex-1">
              {item?.diagnosis
                ?.map((diag) => {
                  return `${diag.code}`;
                })
                ?.join(", ")}
            </span>
          </div>
          <div className="flex items-center flex-1">
            <span className="font-semibold mr-1">2nd Code:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div>
          <div className="flex items-center flex-1">
            <span className="font-semibold mr-1">3th Code:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div>
          <div className="flex items-center flex-1">
            <span className="font-semibold mr-1">4th Code:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div>
        </div>

        <hr className="border-t border-black my-1" />

        <h3 className="text-sm font-bold mb-1">
          Please tick () Where appropriate
        </h3>

        <div className="flex justify-between mb-1">
          <div className="flex space-x-5">
            <span>Chronic ()</span>
            <span>Congenital ()</span>
            <span>Work Related ()</span>
            <span>Vaccination ()</span>
            <span>Check-Up ()</span>
          </div>
          <div className="flex items-center">
            <span className="mr-1">Indicate LMP:</span>
            <span className="border-b border-dotted border-black w-16">334</span>
          </div>
        </div>

        <div className="flex space-x-5 mb-1">
          <span>Psychiatric ()</span>
          <span>Infertility ()</span>
          <span>Pregnancy ()</span>
        </div>

        <p className="text-xs mb-1">
          Suggestive lines of Managment : Kindlay enumerate the recommended
          investigations , and /or procedures
          <b className="font-bold mx-1">For Outpatient approvals Only</b>
        </p>

        <div className="overflow-x-auto mb-2">
          <table className="w-full border border-black text-xs">
            <thead>
              <tr className="border border-black">
                {headerOne.map((item, index) => (
                  <th
                    key={index}
                    className="border border-black p-1 text-center"
                  >
                    {item.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {item?.items?.map((item, index) => (
                <tr key={index} className="border border-black">
                  <td className="border border-black p-1 text-center">
                    {item?.standard_code}
                  </td>
                  <td className="border border-black p-1 text-center">
                    {item?.non_standard_code}
                  </td>
                  <td className="border border-black p-1">
                    <div>{item?.standard_description}</div>
                    {item?.reject_reason_display ? (
                      <div className="text-xs text-red-500 mt-1">
                        <span className="font-semibold">Reject Reason: </span>
                        {item?.reject_reason_display}
                      </div>
                    ) : null}
                  </td>
                  <td className="border border-black p-1 text-center">
                    {item?.type}
                  </td>
                  <td className="border border-black p-1 text-center">
                    {item?.quantity}
                  </td>
                  <td className="border border-black p-1 text-center">
                    {item?.approved_quantity}
                  </td>
                  <td className="border border-black p-1 text-center">
                    {item?.net}
                  </td>
                  <td className="border border-black p-1 text-center">
                    {item?.approved_value}
                  </td>
                  <td className="border border-black p-1 text-center">
                    {item?.status}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="text-xs mb-1">
          Providing approvals /Coding Stff must review /Code the recommended
          Service and collect cose and complete the follwing :
        </p>

        <div className="flex space-x-1 mb-2">
          <div className="flex items-center flex-1">
            <span className="font-semibold mr-1">Completed / Coded By:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div>
          <div className="flex items-center flex-1">
            <span className="font-semibold mr-1">Signature:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div>
          <div className="flex items-center flex-1">
            <span className="font-semibold mr-1">Date:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div>
        </div>

        <div className="overflow-x-auto mb-2">
          <table className="w-full border border-black text-xs">
            <thead>
              <tr className="border border-black">
                {headerTwo.map((item, index) => (
                  <th
                    key={index}
                    className="border border-black p-1 text-center"
                  >
                    {item.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {item?.items?.map((item, index) => (
                <tr key={index} className="border border-black">
                  <td className="border border-black p-1">
                    {`(${item?.standard_code}) - ${item?.standard_description}`}
                  </td>
                  <td className="border border-black p-1 text-center">
                    {item?.type}
                  </td>
                  <td className="border border-black p-1 text-center">
                    {item?.quantity}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="flex items-center space-x-2 mb-1">
          <span>In Case management form (CMF 1.0) included</span>
          <b>Yes () No()</b>
        </div>

        <div className="flex items-center mb-1">
          <span className="font-semibold mr-1">
            Please specify Possible line of management when applicable:
          </span>
          <span className="border-b border-dotted border-black flex-1"></span>
        </div>

        <div className="flex space-x-2 mb-1">
          <div className="flex items-center flex-1">
            <span className="font-bold mr-1">Estimated length of Stay:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div>
          <div className="flex items-center flex-1">
            <span className="font-bold mr-1">Estimated length of Stay:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div>
        </div>
      </div>

      {/* Third Row - Certifications */}
      <div className="border border-black p-1 rounded mb-2">
        <div className="grid grid-cols-2 gap-2">
          {/* Left Certification */}
          <div className="border-r border-gray-300 pr-2">
            <p className="text-xs mb-2">
              I hereby certify that ALL information mentioned are correct and
              that the medical services shown on this form were medically
              indicated and necessary for the management of this case.
            </p>
            <div className="flex justify-between">
              <div className="flex flex-col">
                <span className="font-bold">Physicians</span>
                <span className="border-b border-dotted border-black">
                  {item?.care_teams
                    ?.map((care) => {
                      return `${care.name}`;
                    })
                    ?.join(", ")}
                </span>
              </div>
              <div className="flex flex-col">
                <span className="font-bold">Signature</span>
                <span className="border-b border-dotted border-black"></span>
              </div>
              <div className="flex flex-col">
                <span className="font-bold">Stamp</span>
                <input type="radio" className="mt-1" />
              </div>
              <div className="flex flex-col">
                <span className="font-bold">Date</span>
                <span className="border-b border-dotted border-black"></span>
              </div>
            </div>
          </div>

          {/* Right Certification */}
          <div className="pl-2">
            <p className="text-xs mb-2">
              I hereby certify that ALL statements and information provided
              concerning patient identification and the present illness or
              injury are TRUE.
            </p>
            <div className="mb-1">
              <div className="flex items-center">
                <span className="font-bold mr-1">
                  Name (and relationship (if guardian)):
                </span>
                <span className="border-b border-dotted border-black flex-1"></span>
              </div>
            </div>
            <div className="flex space-x-2">
              <div className="flex items-center flex-1">
                <span className="font-bold mr-1">Signature:</span>
                <span className="border-b border-dotted border-black flex-1"></span>
              </div>
              <div className="flex items-center flex-1">
                <span className="font-bold mr-1">Date:</span>
                <span className="border-b border-dotted border-black flex-1"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Insurance Company Section */}
      <div className="border border-black p-1 rounded">
        <div className="mb-1">
          <div className="flex items-center">
            <span className="font-semibold mr-1">
              For Insurance Company Use Only:
            </span>
            <div className="flex space-x-20">
              <span>Approved ( )</span>
              <span>Not Approved ( )</span>
              <span>Approval No:</span>
              <span>Approval validity:</span>
            </div>
          </div>
        </div>

        <div className="mb-1">
          <span>
            Days Comments (include approved days/services if different from the
            requested):
          </span>
        </div>

        <hr className="border-t border-black my-1" />

        <div className="flex space-x-2">
          <div className="flex items-center flex-1">
            <span className="font-bold mr-1">Approved/Disapproved By:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div>
          <div className="flex items-center flex-1">
            <span className="font-bold mr-1">Signature:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div>
          <div className="flex items-center flex-1">
            <span className="font-bold mr-1">Date:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div>
        </div>
      </div>

      <p className="text-xs font-bold mt-1">
        (*) This is applicable only in case of manual UCAF
      </p>
    </div>
  );
}

function UcafForm({ showUCAF, setShowUCAF, item }) {
  const { t } = useTranslation();
  const handlePrint = () => {
    setShowUCAF(false);

    setTimeout(() => {
      const printContent = document.getElementById("print-content");
      if (!printContent) return;
      printElementToPdf("ucaf", printContent);
    }, 300);
  };

  return (
    <Modal
      // isOpen={true}
      isOpen={showUCAF}
      onRequestClose={() => setShowUCAF(false)}
      style={customStyles}
      overlayClassName="fullscreen-modal-overlay fixed inset-0 bg-black/50 backdrop-blur-sm z-[9999]"
      contentLabel="Example Modal"
    >
      <div id="print-content">
        <UCAFdata item={item} />
      </div>
      <div className="sticky bottom-0 p-4 pt-3">
        <div className="flex justify-end">
          <button
            type="button"
            className="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            onClick={() => setShowUCAF(!showUCAF)}
          >
            {t("Close")}
          </button>
          <button
            type="submit"
            className="ml-3 inline-flex justify-center rounded-md border border-transparent bg-[#0070C2] py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            onClick={() => handlePrint()}
          >
            {t("Print")}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default UcafForm;
